import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

export default function FeedbackContactLinks({ contactLinks }) {
  if (contactLinks.isEmpty()) {
    return null;
  }

  return (
    <div className="cp-feedback-contact-links">
      <h3><FormattedMessage id="feedback_contact_lib_heading" /></h3>
      {contactLinks.entrySeq().map(([localeKey, url]) => <p><a href={url}><FormattedMessage id={localeKey} /></a></p>)}
    </div>
  );
}

FeedbackContactLinks.propTypes = {
  contactLinks: ImmutablePropTypes.mapOf(PropTypes.string, PropTypes.string)
};

FeedbackContactLinks.displayName = 'FeedbackContactLinks';



// WEBPACK FOOTER //
// ./app/components/feedback/FeedbackContactLinks.jsx